(function () {
  if (window.csCosaneaLoaded) return;
  window.csCosaneaLoaded = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initCube(stage) {
    if (stage.dataset.csReady) return;
    stage.dataset.csReady = '1';
    var cube = stage.querySelector('.cs-cube');
    var root = stage.closest('.cs-hero__visual') || stage.parentNode;
    var dots = root.querySelectorAll('.cs-cube-dot');
    var pauseBtn = root.querySelector('.cs-cube-pause');
    var count = parseInt(stage.dataset.count, 10) || 4;
    var interval = parseInt(stage.dataset.interval, 10) || 3500;
    var k = 0;
    var timer = null;
    var paused = reduce || count < 2;
    var hovering = false;

    function render() {
      cube.style.transform = 'translateZ(calc(var(--s) / -2)) rotateY(' + (-90 * k) + 'deg)';
      var current = ((k % 4) + 4) % 4 % count;
      dots.forEach(function (d, i) { d.setAttribute('aria-current', i === current ? 'true' : 'false'); });
    }
    function next() {
      k += 1;
      // Bei weniger als 4 Motiven wiederholt sich die Reihenfolge auf den freien Seiten
      render();
    }
    function start() {
      stop();
      if (!paused && !hovering && !document.hidden) timer = setInterval(next, interval);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function updatePauseLabel() {
      if (!pauseBtn) return;
      pauseBtn.textContent = paused ? 'Abspielen' : 'Pause';
      pauseBtn.setAttribute('aria-pressed', paused ? 'true' : 'false');
    }

    dots.forEach(function (d, i) {
      d.addEventListener('click', function () {
        var face = ((k % 4) + 4) % 4;
        var diff = (i - face + 4) % 4;
        if (diff === 3) diff = -1;
        k += diff;
        render();
        start();
      });
    });
    if (pauseBtn) {
      pauseBtn.addEventListener('click', function () { paused = !paused; updatePauseLabel(); start(); });
    }
    stage.addEventListener('mouseenter', function () { hovering = true; stop(); });
    stage.addEventListener('mouseleave', function () { hovering = false; start(); });
    document.addEventListener('visibilitychange', start);

    updatePauseLabel();
    render();
    start();
  }

  function initReveal(scope) {
    var els = scope.querySelectorAll('.cs-reveal:not(.is-in)');
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.2 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initTicker(el) {
    if (el.dataset.csReady) return;
    el.dataset.csReady = '1';
    var btn = el.querySelector('.cs-ticker__pause');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var paused = el.classList.toggle('is-paused');
      btn.textContent = paused ? 'Abspielen' : 'Pause';
      btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
    });
  }

  function setPressed(btns, active) {
    btns.forEach(function (b) { b.setAttribute('aria-pressed', b === active ? 'true' : 'false'); });
  }

  function initFlavor(card) {
    if (card.dataset.csReady) return;
    card.dataset.csReady = '1';
    var sizes = card.querySelectorAll('[data-role="size"]');
    var fluors = card.querySelectorAll('[data-role="fluor"]');
    var price = card.querySelector('[data-role="price"]');
    var idInput = card.querySelector('[data-role="id"]');
    var submit = card.querySelector('[data-role="submit"]');
    var img = card.querySelector('.cs-shopcard__img');
    var links = card.querySelectorAll('[data-role="link"]');

    function current() {
      var s = card.querySelector('[data-role="size"][aria-pressed="true"]') || sizes[0];
      var f = card.dataset.fluor || '0';
      if (!s.dataset['id' + f]) f = '0';
      return { btn: s, f: f };
    }
    function apply() {
      var c = current(), d = c.btn.dataset, f = c.f;
      if (price) price.textContent = d['price' + f];
      if (idInput) idInput.value = d['id' + f];
      links.forEach(function (a) { a.href = d['url' + f]; });
      if (img && d['img' + f]) { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = d['img' + f]; }
      if (submit) {
        var ok = d['avail' + f] === 'true';
        submit.disabled = !ok;
        submit.textContent = ok ? 'In den Warenkorb' : 'Ausverkauft';
      }
      // Fluorid-Knöpfe nur anbieten, wenn es die gewählte Größe auch mit Fluorid gibt
      fluors.forEach(function (b) { b.disabled = b.dataset.value === '1' && !c.btn.dataset.id1; });
    }
    sizes.forEach(function (b) { b.addEventListener('click', function () { setPressed(sizes, b); apply(); }); });
    fluors.forEach(function (b) { b.addEventListener('click', function () { card.dataset.fluor = b.dataset.value; setPressed(fluors, b); apply(); }); });
    card.csSelectSlot = function (slot) {
      var t = card.querySelector('[data-role="size"][data-slot="' + slot + '"]');
      if (t) { setPressed(sizes, t); apply(); }
    };
  }

  function initAccessory(card) {
    if (card.dataset.csReady) return;
    card.dataset.csReady = '1';
    var sw = card.querySelectorAll('[data-role="swatch"]');
    var idInput = card.querySelector('[data-role="id"]');
    var label = card.querySelector('[data-role="swatch-label"]');
    var img = card.querySelector('.cs-swap-img');
    sw.forEach(function (b) {
      b.addEventListener('click', function () {
        setPressed(sw, b);
        if (idInput) idInput.value = b.dataset.id;
        if (label) label.textContent = b.dataset.label;
        if (img && b.dataset.img) { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = b.dataset.img; }
      });
    });
  }

  function initShop(shop) {
    if (shop.dataset.csReady) return;
    shop.dataset.csReady = '1';
    var bar = shop.querySelector('[data-cs-filters]');
    var groups = shop.querySelectorAll('[data-cs-group]');
    var btns = bar ? bar.querySelectorAll('[data-cs-filter]') : [];
    function filter(name) {
      groups.forEach(function (g) {
        var show = name === 'alle' || g.dataset.csGroup.split(' ').indexOf(name) > -1;
        g.classList.toggle('cs-is-hidden', !show);
      });
      btns.forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.csFilter === name ? 'true' : 'false'); });
      if (name === 'nachfuellen') {
        shop.querySelectorAll('[data-cs-flavor]').forEach(function (c) { if (c.csSelectSlot) c.csSelectSlot(3); });
      }
    }
    if (bar) {
      bar.hidden = false;
      btns.forEach(function (b) { b.addEventListener('click', function () { filter(b.dataset.csFilter); }); });
    }
    shop.querySelectorAll('[data-cs-filter-link]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        filter(a.dataset.csFilterLink);
        var target = shop.querySelector('#cs-sorten');
        if (target) target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      });
    });
  }

  function init(scope) {
    scope.querySelectorAll('[data-cs-flavor]').forEach(initFlavor);
    scope.querySelectorAll('[data-cs-accessory]').forEach(initAccessory);
    scope.querySelectorAll('[data-cs-shop]').forEach(initShop);
    scope.querySelectorAll('[data-cs-cube]').forEach(initCube);
    scope.querySelectorAll('[data-cs-ticker]').forEach(initTicker);
    initReveal(scope);
  }

  document.documentElement.classList.add('cs-js');
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  // Theme-Editor: neu geladene Abschnitte direkt starten
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
